import Repository from '@/repositories/marketing'
const resource = '/sms_messages'

export default {
  sendTestInvalidMessage(payload, config) {
    return Repository.post(`${resource}.json`, payload, config)
  },
  /**
   * Fetches list of sms of a campaign
   * @returns {Promise} Promise containing list of sms of a campaign
  */
  fetchCampaignSms(params) {
    return Repository.get(`${resource}.json`, {params})
  },
  /**
   * Fetches list of message (sms) types 
   * @param {String} accountId Id of the account whose camapign sms types are to be fetched
   * @returns {Promise} Promise containing list of message types of an account
  */
  fetchMessageTypes(params) {
    return Repository.get(`${resource}/message_types.json`, {params})
      }
}